module.exports = __webpack_public_path__ + "img/treebu_logo.5428324c.png";